import config from "../environments/generated.config"

const homeUrl = config.urls.home

const checkIsIframeMode = function () {
  const isIframe = window.self !== window.top
  if (!isIframe) {
    /* eslint-disable */
    console.info("haytek-front: work only in iframe mode", { isIframe })
    window.location.href = homeUrl
  }
  return isIframe
}

export default checkIsIframeMode
